import httpClient from './httpClient'

import auditEndpoints from './auditEndpoints'
import caseArtifactEndpoints from './caseArtifactEndpoints'
import caseEndpoints from './caseEndpoints'
import commentEndpoints from './commentEndpoints'
import countryCodeEndpoints from './countryCodeEndpoints'
import customerEndpoints from './customerEndpoints'
import dealerEndpoints from './dealerEndpoints'
import deviceEndpoints from './deviceEndpoints'
import externalEndpoints from './externalEndpoints'
import internalAdminEndpoints from './internalAdminEndpoints'
import locationEndpoints from './locationEndpoints'
import multiViewEndpoints from './multiViewEndpoints'
import notificationEndpoints from './notificationEndpoints'
import onboardingEndpoints from './onboardingEndpoints'
import recentlyViewedEndpoints from './recentlyViewedEndpoints'
import roleEndpoints from './roleEndpoints'
import scheduleEndpoints from './scheduleEndpoints'
import thumbnailEndpoints from './thumbnailEndpoints'
import timelineEndpoints from './timelineEndpoints'
import timezoneEndpoints from './timezoneEndpoints'
import userEndpoints from './userEndpoints'
import videoEndpoints from './videoEndpoints'
import tokenEndpoints from './tokenEndpoints'
import devicePermissionEndpoints from './devicePermissionEndpoints'
import historyEndpoints from './historyEndpoints'
import smtpServerEndpoints from './smtpServerEndpoints'
import resourceEndpoints from './resourceEndpoints'
import deviceTriggerEndpoints from './deviceTriggerEndpoints'
import externalTokenEndpoints from './externalTokenEndpoints'
import promotionalDeviceEndpoints from './promotionalDeviceEndpoints'
import advancedVcaEventEndpoints from './advancedVcaEventEndpoints'
import purchaseOrderNumberEndpoints from './purchaseOrderNumberEndpoints'
import customerActivityEndpoints from './customerActivityEndpoints'

export default {
  ...auditEndpoints,
  ...caseArtifactEndpoints,
  ...caseEndpoints,
  ...commentEndpoints,
  ...countryCodeEndpoints,
  ...customerActivityEndpoints,
  ...customerEndpoints,
  ...dealerEndpoints,
  ...deviceEndpoints,
  ...externalEndpoints,
  ...internalAdminEndpoints,
  ...locationEndpoints,
  ...multiViewEndpoints,
  ...notificationEndpoints,
  ...onboardingEndpoints,
  ...recentlyViewedEndpoints,
  ...resourceEndpoints,
  ...roleEndpoints,
  ...scheduleEndpoints,
  ...thumbnailEndpoints,
  ...timelineEndpoints,
  ...timezoneEndpoints,
  ...userEndpoints,
  ...videoEndpoints,
  ...tokenEndpoints,
  ...devicePermissionEndpoints,
  ...historyEndpoints,
  ...smtpServerEndpoints,
  ...deviceTriggerEndpoints,
  ...externalTokenEndpoints,
  ...promotionalDeviceEndpoints,
  ...advancedVcaEventEndpoints,
  ...purchaseOrderNumberEndpoints,
  Status: {
    GetAPIStatus() {
      return httpClient.get('/Status')
    },
  },
  Environment: {
    GetSettings() {
      return httpClient.get('/Environment')
    },
  },
  Test: {
    GetInstanceName() {
      return httpClient.get('/Test/GetInstanceName')
    },
  },
}
